import request from './utils/request'

class InfoService {
  static getCountries() {
    return request('GET', 'address/country/')
  }
  static getWorldLanguages() {
    return request('GET', 'address/language/')
  }
  static getWorldTimezones() {
    return request('GET', 'address/timezone/')
  }
  static getAvailableCountries() {
    return request('GET', 'address/available_countries/')
  }
}

export default InfoService
